/**
 * Investment Amount Input Component
 * Input field for investment/subscription amount
 * Extracted from original lines 799-833
 */

import { FC } from "react";
import { Text } from "@mantine/core";
import { INPUT_STYLES, UI_TEXT } from "../StructureNote.constants";
import { validateInvestmentAmount } from "../utils/validation";

interface InvestmentAmountInputProps {
  selectedNoteCurrency: string;
  investorSubscribeAmount: string;
  maxAmount: string;
  onChange: (value: string) => void;
}

/**
 * Input field for investment amount with validation
 * Original logic from lines 799-833
 */
const InvestmentAmountInput: FC<InvestmentAmountInputProps> = ({
  selectedNoteCurrency,
  investorSubscribeAmount,
  maxAmount,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow empty string or validate format (lines 816-820)
    if (inputValue === "" || validateInvestmentAmount(inputValue, maxAmount)) {
      onChange(inputValue);
    }
  };

  return (
    <div>
      <Text
        style={{
          fontWeight: 800,
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        {UI_TEXT.AMOUNT_TO_INVEST} {selectedNoteCurrency}
      </Text>
      <input
        type="text"
        value={investorSubscribeAmount}
        onChange={handleChange}
        style={INPUT_STYLES.investmentAmount}
      />
    </div>
  );
};

export default InvestmentAmountInput;
